import { ReactElement } from "react";
import { BaseFilterProps, Filter, FilterData } from "../../_types";
import { SapExportErrorCategoryFilterComponent } from "./sap-export-error-category-filter-component";

/**
 * Filter for SAP export error category
 * Uses the `errorCategory` field of the customer-sap-export search body schema
 */
export class SapExportErrorCategoryFilter extends Filter<{ errorCategory?: string[] }, Record<string, never>> {
  readonly id: string = "errorCategory";
  readonly labelSingular = "aceSapExportIssues:ColumnCategory";
  readonly labelPlural = "aceSapExportIssues:ColumnCategory";
  readonly placeholder = "aceSapExportIssues:SelectErrorCategory";
  readonly searchPlaceholder = "aceSapExportIssues:SearchErrorCategory";
  readonly emptyText = "aceSapExportIssues:NoErrorCategoryFound";
  body = {};
  parameters = {};

  constructor({ id }: { id?: string } = {}) {
    super();
    if (id) this.id = id;
  }

  getData(): FilterData {
    return { options: [], isLoading: false, error: null };
  }

  render(props: BaseFilterProps): ReactElement {
    return <SapExportErrorCategoryFilterComponent filter={this} {...props} />;
  }
}
